import styled from "styled-components";

import { IThemeProps } from "@/styles";

export const Wrapper = styled.div<IThemeProps>`
  padding: ${({ theme }) => theme.spacing.desktop.s500}px 0;
  text-align: center;
`;

export const SubWrapper = styled.div<IThemeProps>`
  margin: 0 auto;
`;

export const Header = styled.div<IThemeProps>`
  display: inline-flex;
  flex-direction: column;
  margin: 0 14px;
  color: ${({ theme }) => theme.colors.votingOptionHeaderText};
  font-size: ${({ theme }) => theme.typography.h300};
  text-align: center;
  padding-bottom: ${({ theme }) => theme.spacing.desktop.s500}px;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin: 0 7px;
  }
`;

export const Title = styled.div<IThemeProps>`
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.h610};
  border-bottom: ${({ theme }) =>
    `${theme.borders.votingHorizontalLine} solid ${theme.colors.votingHorizontalLine}`};
  padding-bottom: 4px;
  margin-bottom: 2px;
  text-transform: uppercase;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    font-size: ${({ theme }) => theme.typography.h400};
  }
`;

export const Description = styled.div<IThemeProps>`
  font-size: ${({ theme }) => theme.typography.h310};

  @media ${({ theme }) => theme.breakpoints.mobile} {
    font-size: ${({ theme }) => theme.typography.h400};
  }
`;
